import React, { Component } from 'react';
import { Table,Button,Input, Row, Col,Select,Menu,Icon,Modal,Form,DatePicker,message,Radio, Breadcrumb,Checkbox,Upload,Tooltip} from 'antd';
import {GRADE_PART,SUBJECT_PART} from '../../../utils/questionManageType'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import axios from 'axios';
import $ from '$';
import API from '../../../API/api';
import * as questionManageType from '../../../utils/questionManageType'
import storage from '../../../utils/cookie'

const Search = Input.Search;
const Option = Select.Option;
const confirm = Modal.confirm;
const CheckboxGroup = Checkbox.Group;
class MissionList extends Component{
    state={
        page:1,
        pagesize:10,
        total:'',
        l_end:'',
        l_start:'',
        title:'',
        grade:'',
    }
    columns = [
        {
            title: '序号',
            dataIndex: 'article_id',
            key: 'article_id',
            width:80,
        },
        {
            title: '年级',
            dataIndex: 'grade',
            key: 'grade',
            width:100,
        },{
            title: 'L值',
            dataIndex: 'l_value',
            key: 'l_value',
            width:120,

        },{
            title: '标题',
            key: 'title',
            width:200,
            render: (text,record) => {
                return <div>
                    {record.title}
                </div>
            }
        }, {
            title: '描述',
            dataIndex: 'summary',
            key: 'summary',
            width:250,
        },
        {
            title: '文章正文',
            width:250,
            render: (text,record) => {
                return <div>
                    <Tooltip
                        title={<div>
                            {record.content}
                        </div>

                        }
                        mouseEnterDelay={0.5}>
                        <div>
                            {record.content.slice(0,50)+(record.content.length>50?'...':'')}
                        </div>
                    </Tooltip>
                </div>


            }
        },
    ]
    search=()=>{
        this.state.page = 1
        this.setState({page:1})
        if(this.state.l_start<0){
            message.error('L值不能小于0')
            return
        }
         if(this.state.l_end<this.state.l_start){
             message.error('L值区间左侧应小于右侧')
             return
         }
        this.getList()
    }
    handleDownloadTemp = () => {
        // const token = storage.getData('token');
        // const { subject, grade_part } = this.props.user;
        // window.location.href = `${API.FRAMEEWORK_KNOWLEDGE_DOWNLOAD_FORMAT}&token=${token}&subject=${subject}&grade_part=${grade_part}`;
    }
    getList=()=>{
        let data = {
            page:this.state.page,
            pagesize:this.state.pagesize,
            title:this.state.title,
            l_start:this.state.l_start,
            l_end:this.state.l_end,
            grade:this.state.grade,
        }
        axios.post(API.ARTICLE_PAGE_LIST, data).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                this.setState({article_list:res.data.list,total:res.data.total})
            }else{
                message.error(res.message);
            }
        },()=>{message.error("网络错误！")})
    }
    //下载文章

    exportArticletemplate = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.ARTICLE_DOWNLOAD_FORMAT);
        $('body').append(form);  //将表单放置在web中
        form.submit();
        this.setState({exportStatic:false})
    }
    exportArticle = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.ARTICLE_STATISTIC);
        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'title');
        input1.attr('value', this.state.title);

        var input2 = $('<input>');
        input2.attr('type', 'hidden');
        input2.attr('name', 'grade');
        input2.attr('value', this.state.grade);

        var input3 = $('<input>');
        input3.attr('type', 'hidden');
        input3.attr('name', 'l_start');
        input3.attr('value', this.state.l_start);

        var input4 = $('<input>');
        input4.attr('type', 'hidden');
        input4.attr('name', 'l_end');
        input4.attr('value', this.state.l_end);

        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.append(input2);
        form.append(input3);
        form.append(input4);
        form.submit();
        this.setState({exportStatic:false})
    }
    componentDidMount(){
        this.getList()
    }

    render(){
        let data =[]
        this.state.article_list && this.state.article_list.forEach((val)=>{
            val.key = val.article_id
            data.push(val)
        })
        let width = 0;
        for(let key in this.columns){
            width += this.columns[key].width;
        }
        this.state.totalWidth=width

        const token = storage.getData('token');
        //上传知识点树
        const props = {
            name: 'file',
            action: `${API.ARTICLE_BATCH_ADD}&token=${token}`,
            data:{},
            beforeUpload(file) {
                let xls = false
                if(file.type === ''){if(/.xls/.exec(file.name)){xls = true}}
                const notExcel = !(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'||file.type === 'application/vnd.ms-excel'||xls);
                if(notExcel){
                    message.error('上传文件格式不是Excel')
                    return false
                }
            },

            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    if(info.file.response.code === 0) message.success(`${info.file.name} 上传成功`);
                    else message.success(`${info.file.response.message}`);
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败`);
                }
            },
        };

        return(

            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <Link to="/authoritymanage/questionexplain">文章管理</Link>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        {

                            <div style={{fontSize: 14, marginLeft: '20px', display: 'inline-block', float: 'left'}}>
                                <div>
                                    <span style={{marginLeft:30,display: 'inline-block',width:50}}>年级</span>
                                    <Select
                                        placeholder="请选择类型"
                                        style={{display: 'inline-block', width: '60px',marginLeft:0}}
                                        onChange={(val) => {
                                            this.setState({grade: val})
                                        }}
                                        value={this.state.grade}
                                    >
                                        <Option value={'1'}>一年级</Option>
                                        <Option value={'2'}>二年级</Option>
                                        <Option value={'3'}>三年级</Option>
                                        <Option value={'4'}>四年级</Option>
                                        <Option value={'5'}>五年级</Option>
                                        <Option value={'6'}>六年级</Option>
                                    </Select>
                                    <span style={{marginLeft:30,display: 'inline-block',width:50}}>L值区间</span>
                                    <Input placeholder="L值" style={{width:60,marginLeft:20}} onChange={(e)=>{this.setState({l_start:e.target.value})}} value={this.state.l_start}/>
                                    ———
                                    <Input placeholder="L值" style={{width:60}} onChange={(e)=>{this.setState({l_end:e.target.value})}} value={this.state.l_end}/>
                                </div>

                                <div style={{marginTop:'15px'}}>
                                    <span style={{marginLeft:30,display: 'inline-block',width:50}}>标题</span>
                                    <Input placeholder="标题" style={{width:450,marginLeft:0}} onChange={(e)=>{this.setState({title:e.target.value})}} value={this.state.title}/>
                                    <Button type={'primary'} onClick={this.search} style={{marginLeft: '20px'}}>搜索</Button>

                                    <span style={{float:'right'}}>
                                        <Button onClick={this.exportArticletemplate} style={{marginLeft: '20px'}}>导出Excel模版</Button>
                                        <Button onClick={this.exportArticle} style={{marginLeft: '20px'}}>导出Excel</Button>
                                            {
                                                this.props.user.role_know&&this.props.user.role_know.import&&
                                                <Upload
                                                    {...props}
                                                    showUploadList={false}
                                                >
                                                    <Button style={{marginLeft:20}}>
                                                        <Icon type="upload" /> 导入Excel文章
                                                    </Button>
                                                </Upload>
                                            }
                                    </span>

                                </div>
                            </div>
                        }
                    </Col>

                </Row>

                <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20}}>
                    <Table  columns={this.columns} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                </Row>
            </div>
        );
    }

}
const mapStateTopProps = (state) => {
    return {
        user:state.user
    };
}
const mapDispatchToProps = dispatch => {
    return {

    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(MissionList);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/article/view.js